import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/constants";
export default function FAQ() {
  return (
    <main className="sq-container py-12 max-w-3xl" data-testid="faq-page">
      <div className="sq-eyebrow">Help</div>
      <h1 className="font-display text-5xl md:text-6xl mt-2">Frequently Asked</h1>
      <Accordion type="single" collapsible className="mt-10">
        {FAQS.concat(FAQS).map((f, i) => (
          <AccordionItem value={`q${i}`} key={i} className="border-b border-black/10" data-testid={`faq-${i}`}>
            <AccordionTrigger className="font-display text-xl py-6 text-left">{f.q}</AccordionTrigger>
            <AccordionContent className="text-[#4B5563] pb-6">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </main>
  );
}
